import ArticleQuiz from "./ArticleQuiz";
export default ArticleQuiz;